import { Controller } from "react-hook-form";
import moment, { Moment } from "moment";
import { int } from "../../models/base.model";
import { FormInputProps } from "../../models/form.model";
import {
  LocalizationProvider,
  DatePicker,
  DateTimePicker,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

export default function FormDate(
  props: FormInputProps & {
    type: "date" | "datetime" | "time";
    minDate?: Moment;
    minDateTime?: Moment;
    maxDateTime?: Moment;
    minutesStep?: int;
  },
) {
  const { name, control, type, label, helperText, rules, required, setError } =
    props;
  const setErrorMsg = (message: string) => {
    setError(name, { type: "manual", message });
  };
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({
          field: { onChange, value = null },
          fieldState: { error },
          formState,
        }) => {
          switch (type) {
            case "date":
              return (
                <DatePicker
                  label={label}
                  value={value ? moment(value) : value}
                  format="YYYY-MM-DD"
                  className="width-100p"
                  onChange={(newValue: Moment | null) => {
                    onChange(newValue?.format("YYYY-MM-DD"));
                  }}
                  slotProps={{
                    textField: {
                      error: !!error,
                      required: required,
                      helperText: error ? error.message : helperText || null,
                    },
                  }}
                />
              );
            case "datetime":
              return (
                <DateTimePicker
                  label={label}
                  value={value}
                  className="width-100p"
                  onChange={(newValue: Moment | null) => {
                    onChange(newValue);
                  }}
                  format="YYYY-MM-DD HH:mm"
                  minDate={props.minDate}
                  minDateTime={props.minDateTime}
                  maxDateTime={props.maxDateTime}
                  minutesStep={props.minutesStep}
                  slotProps={{
                    textField: {
                      error: !!error,
                      required: required,
                      helperText: error ? error.message : helperText || null,
                    },
                  }}
                />
              );
            case "time":
              return (
                <TimePicker
                  label={label}
                  value={value}
                  className="width-100p"
                  onChange={(newValue: Moment | null) => {
                    onChange(newValue);
                  }}
                  slotProps={{
                    textField: {
                      error: !!error,
                      required: required,
                      helperText: error ? error.message : helperText || null,
                    },
                  }}
                />
              );
            default:
              return <div></div>;
          }
        }}
      />
    </LocalizationProvider>
  );
}
